import * as React from "react";
import { Glyphicon } from "react-bootstrap";
import { IHeaderParams, ColDef } from "ag-grid-community";

interface IProps extends IHeaderParams {
    customSortHandler?: () => void,
    onHeaderItemClick?: () => void,
    overlay?: any,
    menuIcon?: string,
    menuIconLocation?: string,
    title?: string,
    columnName?: string,
    sortAtTop?: boolean
}

type TProps = IProps;

export default class SortableHeaderComponent extends React.Component<TProps, any> {
    constructor(props: TProps) {
        super(props);

        this.props.column.addEventListener('sortChanged', this.onSortChanged);

        //The state of this component contains the current sort state of this column
        //The possible values are: 'asc', 'desc' and ''
        let sort = props.column.getSort();

        this.state = {
            sorted: sort != undefined && sort != '' ? sort : ''
        }
    }

    componentWillUnmount() {
        this.props.column.removeEventListener('sortChanged', this.onSortChanged);
    }

    handleMenuClick = () => {
        if (this.props.onHeaderItemClick != undefined) {
            this.props.onHeaderItemClick();
        } else {
            this.onMenuClick();
        }
    }

    render() {
        let sortElements = [];

        if (this.props.enableSorting) {
            let downArrowClass = "customSortDownLabel " + (this.state.sorted === 'desc' ? " active" : "");
            let upArrowClass = "customSortUpLabel " + (this.state.sorted === 'asc' ? " active" : "");

            sortElements.push(<div key={`up${this.props.displayName}`} className={downArrowClass} onClick={this.onSortRequested.bind(this, 'desc')}><Glyphicon glyph="triangle-bottom" style={{ fontSize: 10, top: 0, marginLeft: 0 }} /></div>);
            sortElements.push(<div key={`down${this.props.displayName}`} className={upArrowClass} onClick={this.onSortRequested.bind(this, 'asc')}><Glyphicon glyph="triangle-top" style={{ fontSize: 10, top: 0, marginLeft: 0 }} /></div>);
        }

        let menuButton = null;

        if (this.props.enableMenu) {
            menuButton = (
                <div ref="menuButton" className="customHeaderMenuButton" onClick={this.handleMenuClick}>
                    <i className={"glyphicon glyphicon-" + this.props.menuIcon} style={{ fontSize: 12 }} />
                </div>
            );
        }

        // console.log(this.props.column.getColId(), menuButton != null && this.props.menuIconLocation == 'LEFT')
        // console.log(this.props.column.getColId(), menuButton != null && this.props.menuIconLocation == 'RIGHT')

        if (this.props.sortAtTop == true) {
            return (
                <div className='sort-at-bottom' title={this.props.title}>
                    {this.state.sorted == 'desc' ? sortElements[0] : null}
                    {this.state.sorted == 'asc' ? sortElements[1] : null}
                    {/* {menuButton && this.props.menuIconLocation == 'LEFT' ? <span style={{ marginRight: 5 }}>{menuButton}</span> : null} */}
                    <div className="customHeaderLabel" style={{ float: null }} onClick={this.handleClick}>
                        {this.props.children}
                        {this.props.columnName}
                    </div>
                    {/* {menuButton && this.props.menuIconLocation == 'RIGHT' ? <span style={{ marginLeft: 5 }}>{menuButton}</span> : null} */}

                    {this.props.overlay}
                </div>
            );
        }

        return (
            <div style={{ display: 'flex', alignItems: 'flex-end' }} title={this.props.title}>
                {menuButton != null && this.props.menuIconLocation == 'LEFT' ? <span style={{ marginRight: 5 }}>{menuButton}</span> : null}
                <div className="customHeaderLabel" onClick={this.handleClick}>
                    {this.props.children}
                    {this.props.columnName}
                </div>
                {menuButton != null && this.props.menuIconLocation == 'RIGHT' ? <span style={{ marginLeft: 5 }}>{menuButton}</span> : null}
                {this.state.sorted == 'desc' ? sortElements[0] : null}
                {this.state.sorted == 'asc' ? sortElements[1] : null}
                {this.props.overlay}
            </div>
        );
    }

    handleClick = () => {
        if (this.props.customSortHandler == undefined) {
            let colDef = this.props.column.getColDef() as ColDef;

            if (colDef.sortable) {
                if (colDef.sortingOrder) {
                    if (this.state.sorted == '') {
                        this.props.setSort(colDef.sortingOrder[0], null);
                    }

                    if (this.state.sorted == colDef.sortingOrder[0]) {
                        this.props.setSort(colDef.sortingOrder[1], null);
                    }

                    if (this.state.sorted == colDef.sortingOrder[1]) {
                        this.props.setSort('', null);
                    }
                } else {
                    if (this.state.sorted == '') {
                        this.props.setSort('asc', null);
                    }

                    if (this.state.sorted == 'asc') {
                        this.props.setSort('desc', null);
                    }

                    if (this.state.sorted == 'desc') {
                        this.props.setSort('', null);
                    }
                }
            }
        } else {
            if (this.state.sorted == '') {
                this.props.customSortHandler();
            } else {
                this.props.setSort('', null);
            }
        }
    }

    onSortRequested(order, event) {
        this.props.setSort(order, event.shiftKey);
    };

    onSortChanged = () => {
        if (this.props.column.isSortAscending()) {
            this.setState({
                sorted: 'asc'
            })
        } else if (this.props.column.isSortDescending()) {
            this.setState({
                sorted: 'desc'
            })
        } else {
            this.setState({
                sorted: ''
            })
        }
    };

    onMenuClick = () => {
        this.props.showColumnMenu((this.refs as any).menuButton);
    };

}

// the grid will always pass in one props called 'params',
// which is the grid passing you the params for the cellRenderer.
// this piece is optional. the grid will always pass the 'params'
// props, so little need for adding this validation meta-data.
// SortableHeaderComponent.propTypes = {
//     params: PropTypes.object
// };